
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  Chapter,
  CourseContentsChapterWithProgress
} from '@/modules/learning/learning.model'
import { mapState, mapGetters, mapMutations } from 'vuex'

@Component({
  computed: {
    ...mapState('learning', ['chapters', 'current_chapter']),
    ...mapGetters('learning', ['courseContentsWithProgress'])
  },
  methods: {
    ...mapMutations('learning', { setCurrentChapter: 'SET_CURRENT_CHAPTER' })
  }
})
export default class ChapterView extends Vue {
  @Prop({ required: true }) readonly course_uuid!: string;
  @Prop({ required: true }) readonly chapter_uuid!: string;

  setCurrentChapter!: (payload: string) => void
  chapters!: Array<Chapter>;
  current_chapter!: Chapter;
  courseContentsWithProgress!: Array<CourseContentsChapterWithProgress>;

  get isChapterView () {
    return this.$route.name === 'chapter.view'
  }

  get currentChapter () {
    const tocChapter = this.courseContentsWithProgress?.find(chapter => chapter.uuid === this.chapter_uuid) || { contents: [], progress: 0, completed: false }
    return {
      ...this.current_chapter,
      ...tocChapter
    }
  }

  @Watch('chapters', { immediate: true })
  @Watch('chapter_uuid', { immediate: true })
  async onChapterChange () {
    if (this.chapters.length > 0) {
      this.setCurrentChapter(this.chapter_uuid)
    }
  }
}

